import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OfferDetailsService } from 'src/app/modules/my-journey/services/offer-details/offer-details.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-applicant-feedback',
  templateUrl: './applicant-feedback.component.html',
  styleUrls: ['./applicant-feedback.component.scss'],
  providers: [OfferDetailsService]
})
export class ApplicantFeedbackComponent implements OnInit {
  @Output() formSaved = new EventEmitter();
  @Input() disable_action;
  @Input() first_login_details;

  feedback = new Feedback();
  question_list = [];
  constructor(
    private feedback_svc: OfferDetailsService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.getFeedbackQuestions()
  }
  getFeedbackQuestions() {
    this.feedback_svc.getFeedbackQuestions().subscribe(res => {
      if (res && res['status'] && res['data'] && res["data"].list) {
        this.question_list = res["data"].list;
        this.feedback.setQuestionObj(this.question_list)
      }
      else {
        this.notification.error(res['message'], 'Close', 3000)
      }
    })
  }
  submitfeedBackDetails() {
    this.feedback_svc.submitFeedbackAnswers(this.feedback).subscribe(res => {
      this.notification.snackbar(res['message'], 'Close', 3000)
    })
  }
  resetfeedBackDetails() {
    this.feedback.setQuestionObj(this.question_list);
  }
}

export class Feedback {
  onboardingAppFeedback;
  questions = []

  setQuestionObj(question_arr) {
    this.questions = [];
    if (question_arr && question_arr.length) {
      question_arr.forEach(question => {
        let obj = {
          questionCode: question.questionCode,
          optionCode: null
        }
        this.questions.push(obj)
      });
    }
  }
}
